<nz-form-item *ngIf="config">
  <nz-form-label [nzSpan]="6">网址</nz-form-label>
  <nz-form-control>
    <input nz-input #nameInput="ngModel" name="value" [(ngModel)]="config.value" />
  </nz-form-control>
</nz-form-item>
<nz-form-item>
  <nz-form-label [nzSpan]="6">图片宽度</nz-form-label>
  <nz-form-control>
    <input nz-input #nameInput="ngModel" name="width" [(ngModel)]="config.width" />
  </nz-form-control>
</nz-form-item>
<nz-form-item>
  <nz-form-label [nzSpan]="6">图片高度</nz-form-label>
  <nz-form-control>
    <input nz-input #nameInput="ngModel" name="height" [(ngModel)]="config.height" />
  </nz-form-control>
</nz-form-item>
